import { INTERVENE_USER_TABS } from '../constants/interveneApi';

const TAB_COUNT_KEYS = {
  [INTERVENE_USER_TABS.INTERVENE]: 'intervene',
  [INTERVENE_USER_TABS.RECENT_15M]: 'min_15',
  [INTERVENE_USER_TABS.ACTIVE_24H]: 'hrs_24',
  [INTERVENE_USER_TABS.HISTORY]: 'history',
};

/**
 * Optimistic badge update when a visible user moves into Intervene.
 */
export function adjustChatCountsForInterveneStart(counts, sourceTab, { userWasVisible = true } = {}) {
  const next = { ...(counts || {}) };
  const sourceKey = TAB_COUNT_KEYS[sourceTab];

  if (userWasVisible && sourceKey && sourceKey !== 'intervene') {
    next[sourceKey] = Math.max(0, (Number(next[sourceKey]) || 0));
  }

  next.intervene = (Number(next.intervene) || 0);
  return next;
}

/**
 * Optimistic badge update when Intervene session ends (exact target tab comes from socket/REST).
 */
export function adjustChatCountsForInterveneEnd(counts) {
  const next = { ...(counts || {}) };
  next.intervene = Math.max(0, (Number(next.intervene) || 0));
  return next;
}
